<template>
    <div id="DetailBox">        
        
        <div class="ctmDetailBox">
            <el-tabs v-model="activeName" type="border-card" @tab-click="elTabClick" stretch>
                <el-tab-pane label="相同行業" name="first">                
                    <div class="searchWrap" style="padding:0">
                        <div class="row">
                            <label>查詢條件：</label>
                            <el-tag :key="tag" v-for="tag in lstIndusCode" type="success" closable :disable-transitions="false" @close="handleClose(tag)">
                                {{tag}}
                            </el-tag>                

                        </div>
                        <div class="row">
                            <label>行業代號：</label>   
                            <IndusCodeSelection 
                                v-model="selectedIndustryCode"
                                @change="handleIndustryCodeChange"
                            />                            
                            <el-button type="primary" icon="el-icon-search" @click="doSearch" style="margin-left:15px;">查詢</el-button>         
                        </div>
                    </div>
                    <div class="content" style="padding:0">
                        <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="tableData" @select="handleSelectionChange">
                        
                        <el-table-column label="統編"   min-width="10%">
                            <template slot-scope="scope">      
                                <el-tooltip content="將開啟新頁" placement="top">                                                            
                                <a class="goDetailPage" @click="doShowCompanyDetail(scope.row)">{{ scope.row.UniComNm }}</a>
                                </el-tooltip>
                            </template>                
                        </el-table-column>   
                        <el-table-column label="公司名稱"  min-width="20%" >
                            <template slot-scope="scope">
                                <el-tooltip content="將開啟新頁" placement="top">
                                <a class="goDetailPage" @click="doshowMap(scope.row)">{{ scope.row.ComName }}</a>
                                </el-tooltip>
                            </template>
                        </el-table-column>                              
                        <el-table-column label="資本額"  prop="_source.tx_Capital" min-width="5%" align="right" >
                            <template slot-scope="scope">
                                {{ formatCapital(scope.row.Cap) }}
                            </template> 
                        </el-table-column>
                        <el-table-column label="成立時間"  prop="_source.tx_SetupDate" min-width="10%">                
                            <template slot-scope="scope">
                                {{ scope.row.ApvDt }}
                            </template> 
                        </el-table-column>              
                        <el-table-column label="地址" prop="ComLoc" min-width="15%">  
                            <!-- <template slot-scope="scope">                        
                                <el-tooltip effect="dark" :content="scope.row._source.tx_Address" placement="right">
                                    <span>{{ formatAddressBrief(scope.row._source.tx_Address) }}</span>
                                </el-tooltip>  
                            </template>                              -->
                        </el-table-column>
                        <el-table-column label="電話" prop="au_phone" min-width="10%" >  
                        </el-table-column>
                        <!-- <el-table-column label="產業別"   min-width="15%">   
                            <template slot-scope="scope">                        
                                <el-tooltip effect="dark" :content="scope.row.au_industrytype" placement="right">
                                    <span>{{ formatBriefing(scope.row.au_industrytype, 15) }}</span>
                                </el-tooltip>  
                            </template>                         
                        </el-table-column>    -->
                        <el-table-column label="既有客戶" prop="au_is_existing_customer"  min-width="10%">                            
                        </el-table-column>                                        
                        <el-table-column label="有進口" prop="au_isImport"  min-width="5%">                            
                            <template slot-scope="scope">
                                {{ String(scope.row.au_is_import || '').trim().length > 0 ? '有' : '無' }}
                            </template>
                        </el-table-column>                                        
                        <el-table-column label="有出口" prop="au_isExport"  min-width="5%">                            
                            <template slot-scope="scope">
                                {{ String(scope.row.au_is_export || '').trim().length > 0 ? '有' : '無' }}
                            </template>
                        </el-table-column>                                        
                        <el-table-column label="有發票" prop="Voice"  min-width="5%">                            
                        </el-table-column>                                                                                  
                        <el-table-column label="供應商" prop="au_isSupplier"  min-width="5%">                            
                            <template slot-scope="scope">
                                {{ String(scope.row.au_is_supplier || '').trim().length > 0 ? '有' : '無' }}
                            </template>
                        </el-table-column>                            
                        </el-table>                
                    </div>
                    <div class="pageBox">
                        <Pagination
                            @currentChange="pageChange"
                            :pageSize="this.listQuery.Page_Size"
                            :propsCurrentPage="this.listQuery.Page_Num"
                            :totalLists="totalLists">
                        </Pagination>
                    </div>  
                </el-tab-pane>
                <el-tab-pane label="關聯公司" name="second">
                    <RelatedCompanyTab 
                        :relComInfo="relComInfo"
                        @show-change="doShowChange"
                    />
                </el-tab-pane>
                <el-tab-pane label="關聯人" name="third">
                    <RelatedPersonTab :relComRep="relComRep" />
                </el-tab-pane>
                <el-tab-pane label="供應商" name="fourth">                
                    <div class="supplierBox">
                        <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="supplierData" @select="handleSelectionChange">
                            <el-table-column label="生產廠場編號"  prop="FtyRegNm" min-width="15%"  >
                            </el-table-column>
                            <el-table-column label="生產廠場名稱"  prop="FtyName" min-width="20%">
                            </el-table-column>                              
                            <el-table-column label="生產廠場地址" prop="FtyLoc" min-width="20%">  
                            </el-table-column>
                            <el-table-column label="生產廠場核可日期"  prop="FtyApvDt" min-width="10%">                
                                <!-- <template slot-scope="scope">
                                    {{ dashFormat(scope.row.FtyApvDt) }}
                                </template>  -->
                            </el-table-column>  
                            <el-table-column label="生產廠場生產設備"  prop="FtyProd" min-width="35%"  >
                            </el-table-column>                              
                        </el-table>    
                        <div class="pageBox">
                            <Pagination
                                @currentChange="supplierPageChange"
                                :pageSize="this.supplierPageSize"
                                :propsCurrentPage="this.supplierPageNum"
                                :totalLists="supplierTotalLists">
                            </Pagination>
                        </div>


                    </div>
                </el-tab-pane>                        
            </el-tabs>
            <div class="buttonBox">            
                <el-button type="danger"  @click="closeWin()" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
            </div>            
        </div>
   
        <el-dialog title="公司資料" :visible.sync="listUsages" width="80%" center>
            <div class="dialogBox" style="height: 550px;overflow-y: auto;">
                <el-table ref="multipleTable" :data="profileList" :show-header="false" :cell-style="{padding: '3px', height: '35px'}" :header-cell-style="{ background: 'transparent'}" style="width: 100%;overflow-y:auto;"  empty-text="暫無數據">
                    <el-table-column label="標題" prop="title" min-width="25%"> </el-table-column>
                    <el-table-column label="內容" prop="value" min-width="75%" ></el-table-column>
                </el-table>
            </div>
          <span slot="footer" class="dialog-footer">
                <el-button type="danger"  @click="closeWin()" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
          </span>
        </el-dialog> 

        <el-dialog title="異動項目" :visible.sync="showModel" width="60%" center>
          <div style="display:flex; flex-direction:column; align-items:center;">
                <el-table ref="multipleTable" :data="changeItemList"  :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%;max-height:300px;overflow-y:auto;"  empty-text="暫無數據">
                <el-table-column label="變更項目" prop="Title" min-width="30%"> </el-table-column>
                <el-table-column label="變更內容" prop="value" min-width="70%"> </el-table-column>                                      
                </el-table>       
          </div>
          <span slot="footer" class="dialog-footer">            
            <el-button type="danger" @click="showModel = false"><font-awesome-icon icon="times" style="margin-right:5px;" />關閉</el-button>
          </span>
        </el-dialog>          
    </div>
</template>

<script>
import { notify, handleError } from '../../utils/notify';
import IndusCodeSelection from '@/components/IndusCodeSelection.vue';
import RelatedCompanyTab from '@/components/RelatedCompanyTab.vue';
import RelatedPersonTab from '@/components/RelatedPersonTab.vue';
import { isTablet as isTabletDevice } from '@/utils/deviceHelper';
import { 
  formatCurrency, 
  formatCapital, 
  formatDate, 
  formatAddressBrief, 
  formatBriefing,
  extractIndustryCode,
  splitIndustryCode 
} from '../../utils/formatters'; // 新增格式化工具
import Pagination from '../../components/Pagination.vue';

export default {
  components: { 
    IndusCodeSelection,
    RelatedCompanyTab,
    RelatedPersonTab,
    Pagination
  },

    data() {
        return {
            showModel: false,
            changeItemList: [],
            selectedIndustryCode: [], // 單選：['A', '01', '011', '0111']
            activeName: "first", // 預設 tabs 激活值為第一個標籤
            ComId : "",
            relComRep: [],            
            relComInfo: [],
            supplierData: [], 
            supplierTotalLists: 0,
            supplierPageNum: 1,
            supplierPageSize: 10,

            tableData:[],
            listUsages: false,
            totalLists:0,
            lstIndusCode:[],
            
            profileList: [],

            listQuery: {
                ie_Import:"有",
                ie_Export:"有",
                tx_UseInvoice:"Y",
                comLoc:"",
                tx_IndustryCode:"",
                comStatus:"核准設立",
                searchContent:"",
                totCap:["",""],
                Page_Size:10,
                Page_Num:1
            },      
            
            indusCodes: [],
        }        
    },
    methods: {
        formatCurrency,
        formatCapital,
        formatDate,
        formatAddressBrief,
        formatBriefing,
        extractIndustryCode,
        splitIndustryCode,        

        handleIndustryCodeChange(value, selectedItems) {
            selectedItems.forEach(item => {
                if (!this.lstIndusCode.includes(item.label)) {
                    this.lstIndusCode.push(item.label);
                    // 同時也要加入搜尋條件
                    console.log(item);
                    this.indusCodes.push({ IndusType: item.label, IndusNm: item.value } );
                    console.log(this.indusCodes);
                }
            });

            // 加入後, 清除選取
            this.selectedIndustryCode = [];    
        },

        supplierPageChange(val) {
            this.supplierPageNum = val;
            this.loadSupplierData();
        },

        async loadSupplierData() {
            this.$store.dispatch("loadingHandler", true);
            const qry = {
                "Page_Size": this.supplierPageSize,
                "Page_Num": this.supplierPageNum,    
                "UniComNm": this.ComId
            };    
            console.log('查詢供應商參數:', qry);                    
            await this.$api.apidata.get_apv_supply(qry).then((res) => {
                console.log('供應商資料:', res);
                this.supplierData = res.data;
                this.supplierTotalLists = parseInt(res.total);
            }, err => {
                handleError(err, '網路發生錯誤');
            });
            this.$store.dispatch("loadingHandler", false);
        },

        compareSupervisor(before, after) {
            let bName = before.map(x=>x.Name);
            let aName = after.map(y=>y.Name);
            let union = bName.concat(aName);
            //console.log(union);
            let adds = union.filter( x=> ! bName.includes(x));
            let subs = union.filter( x=> ! aName.includes(x));
            //console.log(adds, subs);
            adds.forEach(x=> {
                this.changeItemList.push( {Title: "新增董監事", value : x});
            })
            subs.forEach(x=> {
                this.changeItemList.push( {Title: "刪除董監事", value : x});
            })  
            
            // 比對內容.. 名字相同
            const interName = bName.filter(value => aName.includes(value));
            //console.log(interName);
            interName.forEach(z=>{
                let bObj = before.find(y=>y.Name==z);
                let aObj = after.find(y=>y.Name==z);
                //console.log(bObj,aObj);
                if( bObj.LegPersonRep!=aObj.LegPersonRep ) 
                {
                    const bstr = bObj.LegPersonRep ? bObj.LegPersonRep : "無";
                    const astr = aObj.LegPersonRep ? aObj.LegPersonRep : "無";
                    if(!( bstr=="無" && astr=="無"))
                        this.changeItemList.push( {Title: "董監事 "+ z + " 所代表法人變更", value : bstr  + " -> " + astr   });
                }
                if( bObj.HoldStkNm!=aObj.HoldStkNm )
                    this.changeItemList.push( {Title: "董監事 "+ z + " 持有股份數(股)變更", value : bObj.HoldStkNm + " -> " + aObj.HoldStkNm});  
                if( bObj.JobTitle!=aObj.JobTitle )
                {
                    const bstr = bObj.JobTitle ? bObj.JobTitle : "無";
                    const astr = aObj.JobTitle ? aObj.JobTitle : "無"; 
                    if(!( bstr=="無" && astr=="無"))              
                        this.changeItemList.push( {Title: "董監事 "+ z + " 職稱變更", value : bstr  + " -> " + astr});  
                }
                                
            });
        },

        compareManger(before, after) {

            let bName = before.map(x=>x.Name);
            let aName = after.map(y=>y.Name);
            let union = bName.concat(aName);
            //console.log(union);
            let adds = union.filter( x=> ! bName.includes(x));
            let subs = union.filter( x=> ! aName.includes(x));
            //console.log(adds, subs);
            adds.forEach(x=> {
                this.changeItemList.push( {Title: "新增經理人", value : x});
            })
            subs.forEach(x=> {
                this.changeItemList.push( {Title: "刪除經理人", value : x});
            })
        },        
        
        compareBizItems(beforeStr, afterStr) {


            let bName = [];
            let aName = [];
            const regPattern=/(?<item>[A-Z]{1,2}\d{5,6}[\u4e00-\u9fa5\u3002\uff1b\uff0c\uff1a\u201c\u201d\uff08\uff09\u3001\uff1f\u300a\u300b]+)/mg; 

            let match = regPattern.exec(beforeStr);
            do {
                bName.push(match.groups.item);
            } while((match = regPattern.exec(beforeStr)) !== null);

            let match1 = regPattern.exec(afterStr);
            do {
                aName.push(match1.groups.item);
            } while((match1 = regPattern.exec(afterStr)) !== null);


            let union = bName.concat(aName);
            //console.log(union);
            let adds = union.filter( x=> ! bName.includes(x));
            let subs = union.filter( x=> ! aName.includes(x));
            //console.log(adds, subs);
            adds.forEach(x=> {
                this.changeItemList.push( {Title: "新增營業項目", value : x});
            })
            subs.forEach(x=> {
                this.changeItemList.push( {Title: "刪除營業項目", value : x});
            })
        },

        getChangeItems(before, after) {
            this.changeItemList = [];
            
            if(before.PUCap!=after.PUCap){
                this.changeItemList.push( {Title: "實收資本額(元)", value : this.commaFormat( before.PUCap) + " -> " + this.commaFormat(after.PUCap)});
            }
            if(before.ComStatus!=after.ComStatus){
                this.changeItemList.push( {Title: "公司狀況", value : before.ComStatus + " -> " + after.ComStatus});
            }     
            if(before.BizItem!=after.BizItem){
                // this.changeItemList.push( {Title: "所營事業資料", value : before.BizItem + " -> " + after.BizItem});
                this.compareBizItems(before.BizItem,after.BizItem);
            }  
            if(before.ComName!=after.ComName){
                this.changeItemList.push( {Title: "公司名稱", value : before.ComName + " -> " + after.ComName});
            }
            if(before.RepName!=after.RepName){
                this.changeItemList.push( {Title: "代表人姓名", value : before.RepName + " -> " + after.RepName});
            }
            if(before.ComLoc!=after.ComLoc){
                this.changeItemList.push( {Title: "公司所在地", value : before.ComLoc + " -> " + after.ComLoc});
            }
            if(before.TotCap!=after.TotCap){
                this.changeItemList.push( {Title: "資本總額(元)", value : this.commaFormat(before.TotCap) + " -> " + this.commaFormat(after.TotCap)});
            }
            if(JSON.stringify(before.Manager)!=JSON.stringify(after.Manager)){
                // this.changeItemList.push( {Title: "經理人資料", value : before.Manager + " -> " + after.Manager});
                this.compareManger(before.Manager,after.Manager);
            }       
            if(JSON.stringify(before.Supervisor)!=JSON.stringify(after.Supervisor)){
                // this.changeItemList.push( {Title: "董監事資料", value : JSON.stringify(before.Supervisor) + " -> " + JSON.stringify(after.Supervisor)});
                this.compareSupervisor(before.Supervisor,after.Supervisor);
            }    
            //console.log(this.changeItemList);   
        },        

        async doShowChange(data) {
            this.$store.dispatch("loadingHandler", true);
            try {
                const qryCom = { UniComNm: data.UniComNm, DataDt: data.strdate };
                console.log(qryCom);
                const res = await this.$api.apimgrs.getComChange(qryCom);
                console.log(res.Before, res.After);
                this.getChangeItems(res.Before, res.After);
                this.showModel = true;
            } catch (err) {
                this.$notify.error({
                    title: "錯誤",
                    message: "網路發生錯誤",
                    type: "Error"
                });
            } finally {
                this.$store.dispatch("loadingHandler", false);
            }
        },        

        elTabClick() {
            console.log(this.activeName);
        },

        handleClose(tag) {
            // 如果要刪除的標籤不在this.indusCodes中, 則不處理
            if( !this.indusCodes.find(code => code.IndusType === tag) ) {
                notify({title: '警告', message:`標籤 ${tag} 不是行業代碼，因此不進行刪除!`, type: 'Warning'});
                return;
            }
            this.lstIndusCode.splice(this.lstIndusCode.indexOf(tag), 1);
            // 同時也要移除搜尋條件
            this.indusCodes = this.indusCodes.filter(code => code.IndusType !== tag);
            console.log(this.lstIndusCode);
        },

        closeWin() {
            this.listUsages = false;
        },

        addTags(tag) {
            this.lstIndusCode.push(tag);
            console.log(this.lstIndusCode);
        },

        async doShowCompanyDetail(data) {
            console.log(data);
            const comid = data.UniComNm;
            const comname = data.ComName;

            this.$queryRecord(this, comname, 'company');  // 記錄點擊公司名

            // 開啟新視窗, 顯示公司詳細資訊
            const url = `/companyDetail?comid=${comid}&comname=${comname}`;
            window.open(url, '_blank');		
            
        },       
        doshowMap(row) {
            console.log(row);

            this.$queryRecord(this, row.ComName, 'company');  // 記錄點擊公司名
            
            const forceTablet = (process.env.VUE_APP_FORCE_TABLET || '').toLowerCase() === 'true';
            if( isTabletDevice() || forceTablet) {
                // 平板版, 開新頁面, 標籤資訊頁                
                console.log('平板裝置或強制平板模式，開啟地圖頁面');
                const routeData = this.$router.resolve({
                    name: 'm-map-com',
                    query: { unicomnm: row.UniComNm},
                });
                window.open(routeData.href, '_blank');
            }
            else {
                // PC版, 開新頁面, 轉到ctmMapCx.vue頁面
                const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;            
                window.open(url, '_blank');
            }


        },         

        async doSearch(){
            this.listQuery.Page_Num=1;            
            await this.getList();
        },

        async pageChange(val) {
            this.listQuery.Page_Num = val;
            await this.getList();
        },           
        
        async getRelComList() {
            // console.log(this.listQuery);
            const qry = {UniComNm : this.ComId};
            await this.$api.apimgrs.relCompanyInfo(qry).then((res)=>{
                //console.log(res);
                console.log(res.CompanyData, res.LegPersonRepData);
                
                this.relComInfo = [];   
                let temp = [];

                res.LegPersonRepData.forEach(x=>{
                    let rep = x.RelationPeople.map(y=>y.Name).join('<br/>');
                    let jt = x.RelationPeople.map(y=>y.JobTitle).join('<br/>');                
                    this.relComInfo.push( { LegPersonRep: x.LegPersonRep, Rels: jt, Reps: rep, DataDt: x.DataDt, UniComNm: x.UniComNm });
                });
                    
                console.log(this.relComInfo);

                this.relComRep = [];
                res.CompanyData.forEach(x => {
                    let relcoms = x.RelationCompany.map(y=>y).join('<br/>');                
                    this.relComRep.push( { Name: x.Name, JobTitle: x.JobTitle , LegPersonRep: x.LegPersonRep, HoldStkNm: x.HoldStkNm, RelComs: relcoms });
                });
                
                }, err=> {
                    handleError(err, '網路發生錯誤');
                });            
        },        

        async getList() {
            this.$store.dispatch("loadingHandler", true);
            //搜尋"相同縣市區"內"相同行業代號"，且資本額大於1000萬的公司 ...
            //const ic = this.indusCodes[0];// 取第一個行業代號, 未來支援多個列表
            const qry = {
                City: this.$route.query.city,
                District: this.$route.query.district,
                IndusNm : this.indusCodes.map(x=>x.IndusNm),
                CapMin : 1000 * 10000, // 1000萬
                Page_Size: 10,
                Page_Num: this.listQuery.Page_Num
            }

            console.log('查詢參數:', qry);
            await this.$api.apibidmain.search_bidmain(qry).then((res)=>{
                console.log('查詢結果:', res);
                this.tableData = res.data;
                this.tableData.forEach(x => {
                    // 先判斷是否為array , 若是, 把取出每一個x.name , 並合併成一個字串, 用 / 分隔
                    if( Array.isArray(x.au_phone) ) {
                        x.au_phone = x.au_phone.map(y=>y.name).join('/');
                    }
                    

                });
                this.totalLists = parseInt(res.total);
                }, err=> {
                    handleError(err, '網路發生錯誤');
            });

            this.$store.dispatch("loadingHandler", false);
        },

        handleSelectionChange(val) {
            console.log("checked",val);
            this.selectData = val;
        },   

        closeWin() {
            window.close();
        },   

        commaFormat(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            const raw = String(value).replace(/,/g, '');
            const num = Number(raw);
            if (Number.isNaN(num)) {
                return String(value);
            }
            return num.toLocaleString('zh-TW');
        },

        millionStr(intPart) {
            let newPart = Math.trunc(intPart);
            return newPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');            
        },                  
    },
    computed: {
    },    
    async mounted() {
        this.$store.dispatch("loadingHandler", true);

        // 讀取 query 參數
        const params = this.$route.query;
        console.log('路由參數:', params);

        if( params && params.indusCodes ) { // 多個行業代號
            this.indusCodes = JSON.parse(params.indusCodes);
            console.log("IndusCodes", this.indusCodes);
            // this.lstIndusCode = params.indusCodes.split(',');
            //await this.searchPrefix(this.lstIndusCode[0]);
            // 相同縣市
            this.lstIndusCode.push(params.city+params.district);
            // 1000萬以上
            this.lstIndusCode.push('1000萬以上');

            this.indusCodes.forEach( x => {
                this.lstIndusCode.push(x.IndusType);
            } );


        }


        //console.log("ComName",this.qry);
        this.ComId = params.id;
        if( params.comname )
            document.title = '相似企業-' + params.comname ;
        await this.getList();
        await this.getRelComList();
        await this.loadSupplierData();
        this.$store.dispatch("loadingHandler", false);
    }    
}
</script>

<style lang="scss" scoped>
// * {
//     outline: 1px solid red;
// }
#DetailBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;

    .ctmDetailBox {
        padding: 20px 5%;
        margin: 0;
    }

  .searchWrap   {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;

    .row {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        padding: 0px 5%;
        flex-wrap: wrap;

        label {
            margin: 5px 5px;  
            white-space: nowrap;
            font-weight: bold;
            font-size:medium;
        }
        .el-tag {
            margin: 5px 5px;  
            font-weight: bold;
            font-size:medium;
        }
        .button-new-tag {
            margin: 5px 5px;  
            height: 32px;
            line-height: 30px;
            padding-top: 0;
            padding-bottom: 0;
        }
        .input-new-tag {
            width: 150px;
            margin: 5px 5px;  
            vertical-align: bottom;
        }

        button {
            text-align: right;
        }
    }
  }

  .buttonBox {
    padding: 0 5%;
    display: flex;
    justify-content: center;

  }

  .content {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-start;
    padding: 0px 5%;
    .el-table {
        width: 100%;
        margin-top: 20px;
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   }  

  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
   }
}
</style>